import { useDispatch, useSelector } from "react-redux"

/**
 * Typed hooks for Redux to avoid TypeScript errors when checkJs is enabled
 * These are just JavaScript wrappers that provide better type inference
 */

/**
 * @typedef {Object} RootState
 * @property {Object} mediaPlayer
 * @property {Object} mediaPlayer.value
 * @property {Object|null} mediaPlayer.value.currentMediaItem
 * @property {string} mediaPlayer.value.playerState
 * @property {Array} mediaPlayer.value.queue
 * @property {Object} bandDiscography
 */

/**
 * Use this instead of plain `useSelector` to avoid TypeScript errors
 * @template T
 * @param {(state: RootState) => T} selector
 * @returns {T}
 */
export const useAppSelector = (selector) => {
  return useSelector(selector)
}

/**
 * Use this instead of plain `useDispatch`
 */
export const useAppDispatch = () => useDispatch()
